import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonImg,
  IonModal,
  IonRow,
  IonToolbar,
} from "@ionic/react";
import React, { useState } from "react";
import {
  bhpRwaBusinessDetailsUrl,
  bhpRwaPersonalDetailsUrl,
} from "../types/data_types";
import { add, card, close, logoWhatsapp, pencil } from "ionicons/icons";
import {
  BhpThemeHeaderWithBack,
  BusinessHomePageSection,
} from "../pages/BussinessHomePage";
import { useAppSelector, useModalController } from "../app/hooks";
import Card from "../UI/Card";
import { whatsappMessage } from "../types/constants";
import ContentWithBackground from "../UI/ContentWithBackground";
import { getSessionDetails } from "../common/cookies";

const BhpCreateBizCardModal: React.FC<{
  isOpen: boolean;
  onDidDismiss: () => void;
}> = (props) => {
  const points: {
    title: string;
    img: string;
    points: { problem: string; solution: string[] };
  }[] = [
    {
      title: `Save 100% Printing Cost`,
      img: "assets/vBizCard.png",
      points: {
        problem:
          "A physical business card comes with repeated print cost and has a tendency to be lost by the customer where needed.",
        solution: [
          `QR business card saves your repeated card printing cost`,
          "Customer scans and saves your contact on phone, never to be lost",
        ],
      },
    },
    {
      title: "Boost Customer Engagement",
      img: "assets/vBizCard-form.png",
      points: {
        problem:
          'It is hard to compress your business offerings in a 3"x2" business card',
        solution: [
          "Showcase both your personal and businesses information",
          "Customer can view latest offers and trending products anytime, anywhere",
        ],
      },
    },
    {
      title: "10X Your Reach",
      img: "assets/vBizCard-online.png",
      points: {
        problem:
          "As your business evolves you need to reprint your business card",
        solution: [
          "Digital shareable via whatsapp by you and your customers",
          "Businesses are searchable in VypZee's hyperlocal phygital ecosystem",
        ],
      },
    },
  ];
  const [openDetails, setOpenDetails] = useState(false);
  const detailsModalJsx = (
    <IonModal
      isOpen={openDetails}
      onDidDismiss={() => {
        setOpenDetails(false);
      }}
      breakpoints={[0, 1]}
      initialBreakpoint={1}
    >
      <IonHeader>
        <div
          style={{
            padding: "10px",
            paddingTop: "30px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              color: "var(--ion-color-primary-dark)",
              fontSize: "1.4rem",
              fontWeight: "bold",
            }}
          >
            VypZee Business Card Details
          </div>
          <div>
            <IonButton
              fill="clear"
              size="small"
              color={"danger"}
              onClick={() => {
                setOpenDetails(false);
              }}
            >
              <IonIcon icon={close} slot="start" />
              Dismiss
            </IonButton>
          </div>
        </div>
      </IonHeader>
      <IonContent>
        {points.map((el) => {
          return (
            <Card title={el.title}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ width: "200px" }}>
                  <IonImg
                    src={el.img}
                    onClick={() => {
                      setExpandImg(el.img);
                    }}
                  />
                </div>
                <div style={{ flexGrow: "1" }}>
                  {/* <Card>
                    <div style={{ color: "black" }}>{el.points.problem}</div>
                  </Card> */}
                  <Card statusColor="complete">
                    <div style={{ color: "black", fontWeight: "bold" }}>
                      {el.points.solution.map((el) => {
                        return <div style={{ marginBottom: "10px" }}>{el}</div>;
                      })}
                    </div>
                  </Card>
                </div>
              </div>
            </Card>
          );
        })}
      </IonContent>
    </IonModal>
  );
  const [expandImg, setExpandImg] = useState("");

  const expandingImageJsx = (
    <IonModal
      isOpen={!!expandImg}
      onDidDismiss={() => {
        setExpandImg("");
      }}
    >
      <IonHeader>
        <IonToolbar color={"dark"}>
          <IonButtons slot="end">
            <IonButton
              size="small"
              fill="clear"
              color={"light"}
              onClick={() => {
                setExpandImg("");
              }}
            >
              <IonIcon icon={close} slot="start" /> Dismiss
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent color={"dark"}>
        <IonImg src={expandImg} />
      </IonContent>
    </IonModal>
  );
  return (
    <>
      {expandingImageJsx}
      {detailsModalJsx}
      <IonModal isOpen={props.isOpen} onDidDismiss={props.onDidDismiss}>
        <BhpThemeHeaderWithBack
          title="VypZee Business Card"
          onBack={props.onDidDismiss}
        />
        <ContentWithBackground>
          <div style={{ position: "relative", height: "100%" }}>
            <div
              style={{
                // margin: "20px",
                marginBottom: 0,
                padding: "15px",
                background:
                  "linear-gradient(to bottom right, rgba(0,0,0,0.9),rgba(0,0,0,0.8)",
                border: "1px solid lightgray",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                // borderRadius: "10px",
                fontSize: "1rem",
                color: "yellow",
                fontWeight: "bold",
                position: "absolute",
                bottom: 0,
                zIndex: 10,
                width: "100%",
              }}
            >
              <div
                style={{
                  color: "white",
                  fontSize: "1.1rem",
                  marginBottom: "10px",
                }}
              >
                Get Your New Age Digital Card!
              </div>
              {points.map((el, idx) => {
                return (
                  <div
                    style={{
                      padding: "10px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>{el.title}</div>
                  </div>
                );
              })}
              <div
                style={{ width: "100%", padding: "10px", paddingBottom: "0" }}
              >
                <IonButton
                  expand="block"
                  color={"light"}
                  fill="clear"
                  onClick={() => {
                    setOpenDetails(true);
                  }}
                >
                  <IonIcon icon={add} slot="start" />
                  <span style={{ textTransform: "none" }}>Know More</span>
                </IonButton>
                <IonButton
                  expand="block"
                  size="small"
                  color={"light"}
                  onClick={() => {
                    window.location.assign(`https://demousercard.vypzee.com`);
                  }}
                >
                  <IonIcon icon={card} slot="start" />
                  <span style={{ textTransform: "none" }}>
                    Open Sample Card
                  </span>
                </IonButton>
              </div>
            </div>
            <div style={{ padding: "0 30px" }}>
              <IonImg
                src="assets/vBizCard-online.png"
                alt=""
                onClick={() => {
                  setExpandImg("assets/vBizCard-online.png");
                }}
              />
            </div>
          </div>
        </ContentWithBackground>
        <IonFooter>
          <div style={{ padding: "5px" }}>
            <IonButton
              color={"secondary"}
              expand="block"
              onClick={() => {
                whatsappMessage(
                  "Hello Team VypZee! I am interested in knowing more about vBizCard",
                  "8448338565"
                );
              }}
            >
              <IonIcon icon={logoWhatsapp} slot="start" />{" "}
              <span style={{ textTransform: "none" }}>
                Get Your Digital Card Now
              </span>
            </IonButton>
          </div>
        </IonFooter>
      </IonModal>
    </>
  );
};

const BhpRwaModeFaceButtons: React.FC = () => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  //   const { firstName } = getSessionDetails();
  const userDetails = useAppSelector((state) => state.teacherInfoSelection);
  const [modalOpen, modalClose] = useModalController(
    "modal",
    setOpenModal,
    () => {
      setOpenModal(false);
    }
  );
  const businessCardModalJsx = (
    <BhpCreateBizCardModal
      isOpen={openModal}
      onDidDismiss={() => {
        modalClose();
      }}
    />
  );
  return (
    <>
      {businessCardModalJsx}
      <BusinessHomePageSection
        subHeaderText={userDetails.name}
        headingLine={true}
      >
        <IonGrid>
          <IonRow>
            <IonCol
              size="6"
              onClick={() => {
                window.location.assign(bhpRwaPersonalDetailsUrl);
              }}
            >
              <div
                className="bhp-rwa-top-buttons"
                style={{
                  background:
                    "linear-gradient(45deg, #e4efe9 0%, #a0b4e2 100%)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <IonIcon icon={pencil} />
                  <div style={{ marginLeft: "5px" }}>Personal Details</div>
                </div>
              </div>
              {/* <IonButton expand="block">Business</IonButton> */}
            </IonCol>
            <IonCol
              size="6"
              onClick={() => {
                // window.location.assign(bhpRwaBusinessDetailsUrl);
                modalOpen(true);
              }}
            >
              <div
                className="bhp-rwa-top-buttons"
                style={{
                  background:
                    "linear-gradient(45deg, #fdfcfb 0%, #e2d1c3 100%)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <IonIcon icon={add} />
                  <div style={{ marginLeft: "5px" }}>Business Card</div>
                </div>
              </div>
              {/* <IonButton expand="block">Business</IonButton> */}
            </IonCol>
          </IonRow>
        </IonGrid>
      </BusinessHomePageSection>
    </>
  );
};

export default BhpRwaModeFaceButtons;
export { BhpCreateBizCardModal };
